module.exports = __webpack_public_path__ + "static/assets/7bef658b3f84eebb211d8e46888edfb3.svg";